/**
 * converts a string to a handle
 */
__.handleize = function(str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
}
